import compose from 'recompose/compose';
import ChairRentalDetails from '../components/ChairRentalDetails';
import chairRentalForm from './ChairRentalForm';
import withFetchOwnerPaymentCard from '../../../../common/ownerPaymentCard/withFetchOwnerPaymentCard';

export default compose(
  withFetchOwnerPaymentCard,
  chairRentalForm
)(ChairRentalDetails);
